const getSegmentIndex = segmentId => segmentId.length === 2 ? segmentId[1] : segmentId;
const getSegmentDefaultTravelerIds = segment => {
  return segment !== null && segment !== void 0 && segment.__typename && (segment.__typename === 'SellSeatingPreference' || segment.__typename === 'SellSeatingBeside') ? [0] : [];
};
const transformSellSpecificationSegment = sellSpecificationSegment => {
  return sellSpecificationSegment && {
    ...sellSpecificationSegment,
    travelerIds: sellSpecificationSegment.travelerIds ? sellSpecificationSegment.travelerIds.map(Number) : getSegmentDefaultTravelerIds(sellSpecificationSegment)
  };
};
export const getBounds = _ref => {
  let {
    bounds,
    sellSpecification
  } = _ref;
  return bounds.map(_ref2 => {
    let {
      boundId,
      segments = []
    } = _ref2;
    const sellSpecificationBound = sellSpecification === null || sellSpecification === void 0 ? void 0 : sellSpecification.sellSeatMapBounds.find(sellBound => (sellBound === null || sellBound === void 0 ? void 0 : sellBound.id) === boundId);
    const tripSegments = segments.filter(segment => segment.__typename === 'TripSegment');
    return {
      ...sellSpecificationBound,
      boundIndex: Number(boundId),
      boundName: {
        from: {
          city: tripSegments[0].origin.cityName
        },
        to: {
          city: tripSegments[tripSegments.length - 1].destination.cityName
        }
      },
      sellSeatMapSegments: tripSegments.map(segment => {
        const sellSpecificationSegment = sellSpecificationBound ? sellSpecificationBound.sellSeatMapSegments.find(sellSegment => (sellSegment === null || sellSegment === void 0 ? void 0 : sellSegment.id) === segment.segmentId) : undefined;
        const segmentIndex = Number(getSegmentIndex(segment.segmentId));
        return {
          ...transformSellSpecificationSegment(sellSpecificationSegment),
          boundSegmentIndex: `${boundId}-${segmentIndex}`,
          segmentIndex,
          from: {
            city: segment.origin.cityName,
            iata: segment.origin.code
          },
          to: {
            city: segment.destination.cityName,
            iata: segment.destination.code
          }
        };
      })
    };
  });
};
//# sourceMappingURL=seatMapTransformer.js.map